import { estimators } from "./State.js";
export function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export function validatePhoneNumber(phoneNumber) {
    if (!phoneNumber) return false;

    const normalized = String(phoneNumber).replace(/\D/g, ''); // keep digits only
    return normalized.length === 10 || normalized.length === 11 && normalized.startsWith('1');
}

export function checkPassword(input) {
    const passw = /^[A-Za-z]\w{7,14}$/;
    return (input.match(passw) ? true : false);
}

let secretKey = "6Ldfn6UpAAAAABeliLdCyPr4pj6H7qelYPMwvvd6";

export function getKey() {
    // Obfuscated version of the secret key

    return secretKey;
}

export const getEnv = async (param) => { // get the calendly url from the backend
    try {
        const response = await fetch(
            '/api/url',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': getKey() // this is for protection of the server route
                },
                body: JSON.stringify({ value: param }),
            }
        );
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        return data.url;
    } catch (error) {
        console.error('Error fetching url:', error);
    }

}

export const getGeo = async (param) => { // get the geo location {lat, lon} from the address from the backend
    try {
        const response = await fetch(
            '/api/geolocation',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': getKey() // this is for protection of the server route
                },
                body: JSON.stringify({ value: param }),
            }
        );
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        return data; // {lat, lon}
    } catch (error) {
        console.error('Error fetching address geolocation:', error);
    }

}

export function getDistance(coord1, coord2) { //calculate the distance between two points of {lat,lon}
    const toRadians = (degrees) => degrees * (Math.PI / 180);

    const R = 6371; // Earth's radius in kilometers
    const lat1 = toRadians(coord1.lat);
    const lon1 = toRadians(coord1.lon);
    const lat2 = toRadians(coord2.lat);
    const lon2 = toRadians(coord2.lon);

    const dLat = lat2 - lat1;
    const dLon = lon2 - lon1;

    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1) * Math.cos(lat2) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return Math.round(R * c); // Distance in kilometers
}

export function checkProvince(input) {
    const validProvinces = [
        'AB','BC','MB','NB','NL','NS','NT','NU','ON','PE','QC','SK','YT'
    ];

    if (!input) return '';

    const regex = new RegExp(`\\b(${validProvinces.join('|')})\\b`);
    const match = String(input).toUpperCase().match(regex);

    return match ? match[1] : '';
}

export function checkPostalCode(input) {
    if (!input) return '';

    const cleaned = String(input).toUpperCase().replace(/\s+/g, '');

    // Ensure it has exactly 6 characters after stripping spaces
    if (cleaned.length !== 6) return '';

    // Insert space after the third character
    const formatted = cleaned.slice(0, 3) + ' ' + cleaned.slice(3);

    // Validate with proper Canadian postal code pattern
    const postalCodeRegex = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z] \d[ABCEGHJ-NPRSTV-Z]\d$/;

    return postalCodeRegex.test(formatted) ? formatted : '';
}

export const getClosestEstimatorByAddress = async (address) => {
    const customerCoordinates = await getGeo(address);
    if (!customerCoordinates) return null;

    let closest = null;
    let shortestDistance = Infinity;

    for (const estimator of estimators) {
        if (!estimator.base) continue;

        const estimatorCoordinates = await getGeo(estimator.base);
        if (!estimatorCoordinates) continue;

        const distance = getDistance(estimatorCoordinates, customerCoordinates);

        if (distance < shortestDistance) {
            shortestDistance = distance;
            closest = estimator;
        }
    }

    return closest || null;
};

export const getEstimatorById = (id) => {
    const numericId = Number(id);
    return estimators.find(estimator => estimator.id === numericId) || {};
}
